module.exports = __webpack_public_path__ + "static/media/logo.9f608ec6.png";